module.exports = __webpack_public_path__ + "img/icon77.37dd61a6.png";